<template>
  <div class="usage-record">
    <nav-bar class="nav-bar" titleText="使用记录" fontColor="#333333" @goBack="goBack"></nav-bar>

    <div class="btn-box">
      <div class="btn">
        <div 
          class="left" 
          :class="{active: activeIndex == 0}"
          @click="activeIndex = 0"
        >充值记录</div>
        <div 
          class="right" 
          :class="{active: activeIndex == 1}"
          @click="activeIndex = 1"
        >消费记录</div>
      </div>
    </div>

    <div class="list-box" :style="listBoxStyle">
      <record-list v-if="activeIndex == 0" :key="1"></record-list>
      <consume-list  v-if="activeIndex == 1" :key="2"></consume-list>
    </div>

  </div>
</template>

<script>
import navBar from './components/navBar'
import recordList from './components/recordList'
import consumeList from './components/consumeList'
export default {
  name:"usageRecord",
  data() {
    return {
      activeIndex: 0,
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      page: 0,
      listBoxStyle: {height: '300px'}
    }
  },
  components:{
    navBar,
    recordList,
    consumeList,
  },
  created(){
    if (this.$route.query.token) {
      this.$api.setToken(this.$route.query.token);
    }
    if(this.$route.query.paytype) {
      this.activeIndex = this.$route.query.paytype
    }
  },
  mounted(){
    this.listBoxStyle.height = document.body.clientHeight - (88 + 70) + 'px'
  },
  methods:{
    goBack() {
      if(this.$route.query.type &&this.$route.query.type == 1) {
        this.params('', '', 'goBack')
      }else {
          if(this.$route.query.entrance){
              this.$router.push({
                path: "/sharedHotel/store",
                query: {
                    token:localStorage.getItem('_token'),
                    longitude: localStorage.getItem('longitude'),
                    latitude:localStorage.getItem('latitude'),
                    from:'h5'
                },
            });
          }else{
              this.$router.go(-1)
          }
      }
    }
  }
}
</script>


<style lang="less">
.usage-record {
  height: 100%;
  box-sizing: border-box;
  background: #F5F5F5;
  // padding-top: 158px;
  .btn-box {
    position: fixed;
    z-index: 999;
    left: 0;
    top: 88px;
    width: 100%;
    background: #F5F5F5;
    padding: 15px 12px;
    box-sizing: border-box;
    .btn {
      background: #E1E1E1;
      display: flex;
      border-radius: 21px;
      color: #666666;
      .left {
        flex: 1;
        height: 40px;
        line-height: 40px;
        font-size: 18px;
        font-weight: 600;
        text-align: center;
        border-radius: 21px;
      }
      .right {
        flex: 1;
        line-height: 40px;
        text-align: center;
        font-weight: 600;
        border-radius: 21px;
      }
      .active {
        background: linear-gradient(90deg, #FC740C 0%, #F41A3C 100%);
        color: #fff;
      }
    }
  }
  .list-box {
    width: 100%;
    position: fixed;
    left: 0;
    top: 158px;
    overflow-y: auto;
  }

}
</style>